<div class="main-content table-page table-page--compact notificaciones-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Notificaciones</h1>
        <p>Consulte el historial de avisos del sistema y marque rápidamente las notificaciones pendientes.</p>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Mensaje</mat-label>
              <input matInput type="text" maxlength="20" aria-label="Mensaje" [ngModel]="mensaje" (ngModelChange)="onMensajeChange($event)" />
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Tipo</mat-label>
              <mat-select [ngModel]="tipo" (ngModelChange)="onTipoChange($event)">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let item of tiposKeys" [value]="item">
                  {{ item }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiarBusqueda()">
            <i class="material-icons">close</i>
            <span>Limpiar</span>
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="notificaciones.length > 0; else notificacionesEmptyState">
          <thead>
            <tr>
              <th>Mensaje</th>
              <th>Fecha</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let notificacion of notificaciones">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ notificacion.descripcion || 'Sin mensaje' }}</strong>
                  <span class="table-page__subtext">ID: {{ notificacion.id || '-' }}</span>
                </div>
              </td>
              <td>
                <span class="table-page__text">{{ notificacion.creacion || '-' }}</span>
              </td>
              <td>
                <span class="table-page__text">{{ notificacion.tipo || '-' }}</span>
              </td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getStatusClass(notificacion)">
                  {{ getStatusLabel(notificacion) }}
                </span>
              </td>
              <td class="table-page__actions">
                <button
                  type="button"
                  class="table-page__action-btn"
                  *ngIf="!notificacion.revisado"
                  (click)="marcarVisto(notificacion.id)">
                  <i class="material-icons">check</i>
                </button>
                <span class="table-page__subtext" *ngIf="notificacion.revisado">Sin acciones</span>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #notificacionesEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else notificacionesLoadingState">
            <i class="material-icons">notifications_off</i>
            <strong>No se encontraron notificaciones</strong>
            <span>No hay registros con los filtros actuales.</span>
          </div>
        </ng-template>

        <ng-template #notificacionesLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando notificaciones...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} notificaciones</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button
              *ngIf="isPageNumber(item); else notificacionesPagerEllipsis"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="item === currentPage"
              (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #notificacionesPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
